import axios from "axios";
import React, {useEffect, useState} from "react";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function Crop() {
    const [rows, setRows] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        category: "",
        name: "",
        scientific_name: "",
        description: "",
        image: null
    });
    useEffect(() => {
        fetchCategory();
        fetchData();
    }, []);
    const fetchCategory = () => {
        axios.get(baseUrl + "crop-category/")
            .then((res) => {
                setCategories(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const fetchData = () => {
        setLoading(true);
        axios.get(baseUrl + "crop/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };
    const handleChange = (e) => {
        const {name, value, files} = e.target;
        if (name === "image") {
            setFormData({
                ...formData,
                image: files[0]
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };
    const formSubmit = (e) => {
        e.preventDefault();
        if (!formData.category) {
            Swal.fire("Error",
                "Select Category",
                "error");
            return;
        }
        if (!formData.name) {
            Swal.fire("Error",
                "Enter Crop Name",
                "error");
            return;
        }
        const fd = new FormData();
        fd.append("category",
            formData.category);
        fd.append("name",
            formData.name);
        fd.append("scientific_name",
            formData.scientific_name);
        fd.append("description",
            formData.description);
        if (formData.image) {
            fd.append("image",
                formData.image);
        }
        fd.append("status",
            "1");
        fd.append("addedby",
            userName);
        fd.append("ip_add",
            ipAddress);
        axios.post(baseUrl + "crop/",
            fd,
            {
                headers: {
                    "Content-Type":
                        "multipart/form-data"
                }
            })
            .then(() => {
                Swal.fire("Success",
                    "Crop Saved Successfully",
                    "success");
                fetchData();
                setFormData({
                    category: "",
                    name: "",
                    scientific_name: "",
                    description: "",
                    image: ""
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch((err) => {
                console.log(err);
                Swal.fire("Error",
                    "Unable to Save",
                    "error");
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: "Delete Crop?",
            text: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(baseUrl +
                        "delete-crop/" +
                        id +
                        "/")
                        .then(() => {
                            Swal.fire("Deleted",
                                "Crop Deleted",
                                "success");
                            fetchData();
                        })
                        .catch((err) => {
                            console.log(err);
                            Swal.fire("Error",
                                "Unable to Delete",
                                "error");
                        });
                }
            });
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "category",
            headerName: "Category",
            width: 180,
            renderCell: (params) =>
                params.row.category?.name || "-"
        },
        {
            field: "name",
            headerName: "Crop",
            flex: 1,
            minWidth: 180
        },
        {
            field: "scientific_name",
            headerName: "Scientific Name",
            flex: 1,
            minWidth: 220
        },
        {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 250
        },
        {
            field: "image",
            headerName: "Image",
            width: 120,
            renderCell: (params) => (
                params.row.image ?
                    <img

                        src={params.row.image}

                        alt="crop"

                        style={{
                            width: 50,
                            height: 50,
                            objectFit: "cover",
                            borderRadius: 5
                        }}

                    />
                    :
                    "No Image"
            )
        },
        {
            field: "action",
            headerName: "Action",
            width: 120,
            renderCell: (params) => (
                <button

                    className="btn btn-danger btn-sm"

                    onClick={() =>
                        handleDelete(params.row.id)
                    }

                >

                    Delete

                </button>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="card shadow">

                <div className="card-header">

                    <h4>

                        Crop Master

                    </h4>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4">

                            <label>

                                Category

                            </label>

                            <select

                                className="form-control"

                                name="category"

                                value={formData.category}

                                onChange={handleChange}

                            >

                                <option value="">

                                    Select Category

                                </option>

                                {
                                    categories.map((cat) => (
                                        <option

                                            key={cat.id}

                                            value={cat.id}

                                        >

                                            {cat.name}

                                        </option>
                                    ))
                                }

                            </select>

                        </div>

                        <div className="col-md-4">

                            <label>

                                Crop Name

                            </label>

                            <input

                                type="text"

                                className="form-control"

                                name="name"

                                value={formData.name}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4">

                            <label>

                                Scientific Name

                            </label>

                            <input

                                type="text"

                                className="form-control"

                                name="scientific_name"

                                value={formData.scientific_name}

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                    <div className="row mt-3">

                        <div className="col-md-8">

                            <label>

                                Description

                            </label>

                            <textarea

                                className="form-control"

                                rows="3"

                                name="description"

                                value={formData.description}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4">

                            <label>

                                Image

                            </label>

                            <input

                                type="file"

                                className="form-control"

                                name="image"

                                accept="image/*"

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                    <div className="mt-4">

                        <button

                            className="btn btn-primary"

                            onClick={formSubmit}

                        >

                            Save Crop

                        </button>

                    </div>

                </div>

            </div>
            <div className="mt-4">

                <ERPDataGrid

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: "primary.light",
                        "& .MuiDataGrid-cell:hover": {
                            color: "primary.main"
                        }
                    }}

                    rows={rows}

                    columns={columns}

                    loading={loading}

                    autoHeight

                    pageSizeOptions={[10, 25, 50, 100]}

                    

                />

            </div>

        </section>
    );
}
export default Crop;